import type { FC } from 'react';
import { Next } from './Next';
import { Previous } from './Previous';
import { SliderActionWrapper } from './SliderActions.styled';
import { SliderWithActionsProps } from './types';

export const SliderActions: FC<SliderWithActionsProps> = ({ previous, next, slidesLength, currentSlide, children }) => {
    return (
        <SliderActionWrapper data-testid="slider-actions">
            <Previous onClick={previous} disabled={currentSlide === 0} />
            {children}
            <Next onClick={next} disabled={!!slidesLength && slidesLength - 1 === currentSlide} />
        </SliderActionWrapper>
    );
};

SliderActions.displayName = 'SliderActions';
